import { z } from "zod/v4";

export const canvasSpecifier = z.object({
	id: z.string(),
	pageId: z.string(),
});
export type CanvasSpecifier = z.infer<typeof canvasSpecifier>;
